/** Combined schedule table — loan repayments, existing direct debits and the NEW payments in bold (mirrors the email). */
import { fmtMoney } from "@/lib/regionFmt";

const fmtD = (s) => (s ? new Date(`${s.slice(0, 10)}T12:00:00`).toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" }) : "—");
const TONE = {
  loan: "text-slate-600",
  dd: "text-slate-700",
  new: "bg-amber-50 text-amber-900 font-semibold",
};

export default function GcCombinedTable({ rows, total, kind, maxHeight = "max-h-72" }) {
  if (!rows?.length) return <p className="text-xs text-muted-foreground" data-testid="gc-combined-empty">Nothing to show yet.</p>;
  return (
    <div className={`border rounded overflow-y-auto ${maxHeight}`} data-testid="gc-combined-table">
      <table className="w-full text-xs">
        <thead className="sticky top-0 bg-slate-100 text-[10px] uppercase tracking-wide text-slate-500">
          <tr><th className="text-left px-2 py-1">Date</th><th className="text-left px-2 py-1">Payment</th><th className="text-right px-2 py-1">Amount</th></tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className={`border-t ${TONE[r.source] || ""}`} data-testid={`gc-combined-row-${r.source}-${i}`}>
              <td className="px-2 py-1 whitespace-nowrap">{fmtD(r.date)}</td>
              <td className="px-2 py-1">{r.label}</td>
              <td className="px-2 py-1 text-right tabular-nums">{fmtMoney(r.amount, 2)}</td>
            </tr>
          ))}
          <tr className="border-t bg-amber-100 font-bold text-amber-900" data-testid="gc-combined-total">
            <td className="px-2 py-1" colSpan={2}>{kind === "one_off" ? "One-off payment — total" : "Additional payments — total"}</td>
            <td className="px-2 py-1 text-right tabular-nums">{fmtMoney(total, 2)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
